<div class="sa-app-switcher">
    <div class="sa-daton p-1 d-flex" (click)="open('PULSE')">
        <span class="pulseApp"></span>
        <span class="p-2">Pulse</span>
    </div>
    <div class="sa-saras p-1 d-flex" (click)="open('SARAS')">
        <span class="homeApp"></span>
        <span class="p-2">Saras Home Page</span>
    </div>
</div>